if (document.querySelector('.products-categories ul')) {
	document.querySelector('.products-categories ul').addEventListener('mouseover', evt => {
		let ctx = evt.target.closest('section');
	
		if ((evt.target.tagName == "A") && (!evt.target.classList.contains('--current'))) {
			ctx.querySelectorAll('li.--current').forEach(item => {
				item.classList.remove('--current');
			});

			ctx.querySelectorAll('.category-preview.--current').forEach(item => {
				item.classList.remove('--current');
			});
	
			let newCurrent = evt.target.closest('li');
			let bgColor    = newCurrent.getAttribute('data-bgcolor');
			let target     = newCurrent.getAttribute('data-target');
	
			newCurrent.classList.add('--current');
			document.getElementById(target).classList.add('--current');
			ctx.setAttribute('style', 'background-color: ' + bgColor + ';');
		}
	});
}
